/*
 * File: CheckBoxInput.tsx
 * Author: Austin Robinson
 * Date Created: 11/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { Box, Checkbox, CheckboxProps, FormControl, FormHelperText, FormLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends CheckboxProps {
  name: string;
  label: string;
}

export default function CheckBoxInput({ name, label, ...checkBoxProps }: PropTypes) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error} component="fieldset">
          <Box display="flex" alignItems="center" height="100%">
            <Box>
              <Checkbox
                ref={field.ref}
                checked={field.value ?? false}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.checked);
                }}
                {...checkBoxProps}
              />
            </Box>
            <Box component="label">
              <FormLabel component="legend" sx={{ fontSize: 16 }}>
                {label}
              </FormLabel>
            </Box>
          </Box>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
}
